import { SelectionNoteReferenceMixed } from '../internal';
/**
 * @ignore
 */
export const SelectionWithNoteMixin = (Base) => class extends Base {
    getNote() {
        return this.get("NOTE" /* Tag.Note */, null, SelectionNoteReferenceMixed);
    }
};
//# sourceMappingURL=SelectionWithNoteMixin.js.map